






import Vue from 'vue';
import Component from 'vue-class-component';
import MainMenu from '@/components/dummy/MainMenu.vue';

@Component({
  components: { MainMenu },
})
export default class ClientMenu extends Vue {
  wide: boolean;

  constructor() {
    super();
    this.wide = false;
  }

  get height() {
    return 'height: ' + window.innerHeight + 'px';
  }

  get items() {
    return [
      {
        name: 'calendarvisits', // orders
        title: 'Zamówienia',
        icon: 'shopping-basket',
        link: 'calendarvisits',
        items: [],
      },
      {
        name: 'requests',
        title: 'Zapytania ofertowe',
        icon: 'user-cog',
        items: [],
      },
      {
        name: 'contracts',
        title: 'Umowy',
        icon: 'list-alt',
        items: [],
      },
      {
        name: 'settlements',
        title: 'Rozliczenia',
        icon: 'calendar-alt',
        items: [],
      },
    ];
  }
}
